import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ViewEncapsulation, NgZone, AfterViewInit } from '@angular/core';
import { MapsAPILoader } from '@agm/core';

import { GoogleGeoService } from '../../services'
import { GeoData } from '../../models';

@Component({
    moduleId: module.id,
    selector: 'google-place-autocomplete',
    templateUrl: 'google-place-autocomplete.html',
    styleUrls: ['google-place-autocomplete.css'],
    encapsulation: ViewEncapsulation.None
})

export class GooglePlaceAutocompleteComponent implements AfterViewInit {


    @ViewChild("autocompleteInput") autocompleteInput: ElementRef
    @Input() cssClass: string = 'form-control';
    @Input() placeholder: string = '';
    @Input() ngModelValue: string;
    @Input() componentRestrictions: google.maps.places.ComponentRestrictions;
    @Input() types: string[] = ['(cities)'];
    @Input() disabled: boolean = false;
    @Output() ngModelValueChange = new EventEmitter();
    @Output() onPlaceSelected = new EventEmitter();

    autocomplete: google.maps.places.Autocomplete;
    place: GeoData;

    constructor(private mapsAPILoader: MapsAPILoader,
        private googleGeoService: GoogleGeoService,
        private ngZone: NgZone) { }

    ngAfterViewInit(): void {
        if (this.googleGeoService.mapsApiReady) this.onMapsApiReady();
        else this.googleGeoService.onMapsApiReady.subscribe(() => {
            this.onMapsApiReady();
        });
    }

    onMapsApiReady() {
        this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.nativeElement, {
            types: this.types,
            componentRestrictions: this.componentRestrictions
        });
        this.autocomplete.addListener("place_changed", () => this.placeChanged());
    }

    placeChanged() {
        this.ngZone.run(() => {
            let place: google.maps.places.PlaceResult = this.autocomplete.getPlace();
            if (place.place_id) {
                this.place = new GeoData(place);
                this.onBlur();
                this.onPlaceSelected.emit(this.place);
            }
        });
    }

    onBlur() {
        if (this.place) this.ngModelValue = this.place.name;
        else this.ngModelValue = "";
        this.ngModelValueChange.emit(this.ngModelValue);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/google-place-autocomplete/google-place-autocomplete.component.ts